import { useState } from "react";
import { Layout } from "antd";
import HeaderMain from "./HeaderMain";
import SiderCustom from "../layout/sider";
import { Outlet } from "react-router-dom";
const { Header, Sider } = Layout;

const Home = () => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      >
        <SiderCustom />
      </Sider>
      <Layout>
        <Header className="header">
          <HeaderMain />
        </Header>
        <div className="out-let">
          <Outlet />
        </div>
      </Layout>
    </Layout>
  );
};
export default Home;
